exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myhover[data-v-165af303]:hover{background-color:#d3d3d3;cursor:pointer,}.left-margin[data-v-165af303]{padding-left:50px!important}.sub-total[data-v-165af303]{border-top:1px solid #000;font-style:italic}.sub-top[data-v-165af303]{margin-top:10px}.debit-credit[data-v-165af303]{width:200px!important}.balance-sheet-line-height[data-v-165af303]{line-height:0;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-165af303","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/KycDashboard.vue
// module id = 167
// module chunks = 0